import { render, staticRenderFns } from "./ActivityItemModal.vue?vue&type=template&id=ec40131c&scoped=true"
import script from "./ActivityItemModal.vue?vue&type=script&lang=js"
export * from "./ActivityItemModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityItemModal.vue?vue&type=style&index=0&id=ec40131c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec40131c",
  null
  
)

export default component.exports